"use client";
import { Textarea } from "@headlessui/react";
import { CSSProperties, useId } from "react";
import { IGiftCardFormFields } from "../types";
import { UseFormReturn } from "react-hook-form";
import { applyDataTestId } from "@/utils/testUtils";
import pom from "@/utils/pom";

interface IPersonalMessageComponent {
  title: string;
  placeholder: string;
  form: UseFormReturn<IGiftCardFormFields>;
  giftCardSellingEnabled: boolean;
  merchantColor: string;
}

export const PersonalMessageComponent = ({
  title,
  placeholder,
  form,
  giftCardSellingEnabled,
  merchantColor,
}: IPersonalMessageComponent) => {
  const { register } = form;
  const labelId = useId();
  return (
    <div className="flex flex-col gap-[25px] cursor-pointer">
      <p id={labelId} className="text-[#111928] text-[18px] leading-[30px] font-semibold">
        {title}
      </p>
      <Textarea
        aria-label={labelId}
        data-testid={applyDataTestId(pom.giftCard.personalMessageComponent)}
        style={{ "--focus-border-color": merchantColor } as CSSProperties}
        className={`w-full border border-[#5D5D5D] data-[focus]:outline-none data-[focus]:ring-0 data-[focus]:border-[var(--focus-border-color)] rounded-lg resize-none px-5 py-3 text-base font-medium bg-[#FBFBFB] ${
          !giftCardSellingEnabled ? "opacity-50" : ""
        }`}
        rows={4}
        maxLength={4500}
        placeholder={placeholder}
        {...register("personalMessage")}
        disabled={!giftCardSellingEnabled}
      />
    </div>
  );
};
